import { render, staticRenderFns } from "./FullScreenVideo.vue?vue&type=template&id=231da869&scoped=true&"
import script from "./FullScreenVideo.vue?vue&type=script&lang=js&"
export * from "./FullScreenVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231da869",
  null
  
)

export default component.exports